<div class="add-attendence">

  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="icon">
        <div class="icon-circle ml-2"><i class="fal fa-clock pt-1"></i></div>
      </div>
      <div class="text">
        <div class="font-18 font-bold black tml-heading">Add timelog</div>
        <div class="font-11 font-500 gray-55 tml-sub-header">Add a new time log to technician's worksheet</div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeAttendenceModal({})"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="ui-g">
      <div class="ui-g-12 p-zero pl-0 active-green">
        <app-switch-button valueField="value" paddingClass="p-1" [disabled]="" [fontSize]="11"
          [showselectedCircle]="false" [value]="attendence?.type" [showIcons]="false" [options]="attendenceTypes"
          (appChange)="handleChange('isClockIn', $event)">
        </app-switch-button>
      </div>

      <!-- Repair order dropdown -->
      <div class="ui-g-12 p-zero pl-0 pt-2" *ngIf="attendence?.type?.value ==='service'">
        <div class="dropdown-icon ui-g-1">
          <i class="far font-bold fa-file-alt pt-2"></i>
        </div>

        <div class="ui-g-11">
          <div class="input-general-settings-wrapper input-default-style margin-zero">
            <div class="qbo-autocomplete">
              <app-auto-complete placeholder="Search Repair order" theme="light" scrollHeight="165px" name="code"
                field="code" [floatingLabel]="false" [value]="techAttendence?.code" [suggestions]="dupTechRO"
                [isDropdownIconVisible]="true" [fontSize]="14" [listItemFontSize]="10" (appFocus)="focusInput('code')"
                (appBlur)="blurInput('code')" [disabled]="dupTechRO.length === 0" [errorMessage]="errors?.orderId"
                [hasError]="errors?.orderId" (appSelect)="handleSelect('code', $event)"
                (appCompletedMethod)="onSearchItem('code',$event)" (appClear)="handleClear('code',$event)">
              </app-auto-complete>
              <span class="ml-2 font-10 red" *ngIf="errors.orderId">{{errors.orderId}}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Service dropdown -->
      <div class="ui-g-12 p-zero pl-0 pt-0" *ngIf="attendence?.type?.value ==='service'">
        <div class="dropdown-icon ui-g-1">
          <i class="far font-bold fa-wrench pt-2"></i>
        </div>

        <div class="ui-g-11">
          <div class="input-general-settings-wrapper input-default-style margin-zero">
            <div class="qbo-autocomplete">
              <app-auto-complete placeholder="Search Service" theme="light" scrollHeight="165px" name="label"
                field="title" [floatingLabel]="false" [value]="techAttendence?.title" [suggestions]="dupServices"
                [isDropdownIconVisible]="true" [fontSize]="14" [listItemFontSize]="10" (appBlur)="blurInput('title')"
                [errorMessage]="errors?.workId" [hasError]="errors?.workId" (appSelect)="handleSelect('title', $event)"
                [disabled]="!techAttendence?.orderId" (appCompletedMethod)="onSearchItem('title',$event)"
                (appClear)="handleClear('title',$event)">
              </app-auto-complete>
              <span class="ml-2 font-10 red" *ngIf="errors.workId">{{errors.workId}}</span>

            </div>
          </div>
        </div>

      </div>

      <!-- Status dropdown -->
      <div class="ui-g-12 p-zero pl-0 pt-0" *ngIf="attendence?.type?.value ==='service'">
        <div class="dropdown-icon ui-g-1">
          <i class="far font-bold fa-user-hard-hat pt-2"></i>
        </div>
        <div class="ui-g-11">
          <div class="input-general-settings-wrapper input-default-style margin-zero">
            <div class="qbo-autocomplete">
              <app-auto-complete placeholder="Select Status" theme="light" scrollHeight="165px" name="itemRef"
                field="label" [floatingLabel]="false" [value]="techAttendence.actionLabel" [suggestions]="statusTypes"
                [isDropdownIconVisible]="true" [fontSize]="14" [listItemFontSize]="10" (appBlur)="blurInput('action')"
                [errorMessage]="errors?.action" [hasError]="errors?.action" (appSelect)="handleSelect('action', $event)"
                [disabled]="!techAttendence?.orderId || !techAttendence?.title"
                (appCompletedMethod)="onSearchItem('action',$event)" (appClear)="handleClear('action',$event)">
              </app-auto-complete>
              <span class="ml-2 font-10 red" *ngIf="errors.action">{{errors.action}}</span>

            </div>
          </div>
        </div>

      </div>

      <!-- start Time -->
      <div class="ui-g-12 p-zero pl-0 pt-0" *ngIf="attendence?.type?.value ==='service'">
        <!-- <div class="dropdown-icon ui-g-1">
          <i class="far font-bold fa-clock pt-2"></i>
        </div> -->

        <div class="ui-g-6">
          <div class="input-general-settings-wrapper input-default-style margin-zero"
            [ngClass]="{'no-drop': !techAttendence?.orderId || !techAttendence?.title}">
            <div class="time-autocomplete timelog-field">
              <kendo-timepicker [(value)]="serviceStartTime"
                [disabled]="!techAttendence?.orderId || !techAttendence?.title"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"
                (valueChange)="handleServiceTime('serviceStartTime')">
              </kendo-timepicker>
              <div class="ml-2 font-10 red" *ngIf="startTimeOverLap">Overlapping detected</div>
              <div class="ml-2 font-10 red" *ngIf="isValidStartTime">Invalid Start time</div>
              <div class="ml-2 font-10 red" *ngIf="errors.serviceStartTime">{{errors.serviceStartTime}}</div>
            </div>
          </div>
        </div>

        <!-- <div class="dropdown-icon ui-g-1">
          <i class="far fa-clock pt-2"></i>
        </div> -->


        <!-- End Time -->
        <div class="ui-g-6">
          <div class="input-general-settings-wrapper input-default-style margin-zero"
            [ngClass]="{'no-drop': !techAttendence?.orderId || !techAttendence?.title}">
            <div class="time-autocomplete">
              <kendo-timepicker [(value)]="serviceEndTime"
                [disabled]="!techAttendence?.orderId || !techAttendence?.title"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }" (valueChange)="handleServiceTime('serviceEndTime')">
              </kendo-timepicker>
              <!-- <span class="ml-2 font-10 red" *ngIf="isValidEndTime">Invalid End time</span> -->
              <div class="ml-2 font-10 red" *ngIf="endTimeOverLap">Overlapping detected</div>
              <div class="ml-2 font-10 red" *ngIf="isValidEndTime">Invalid End time</div>
              <div class="ml-2 font-10 red" *ngIf="errors.serviceEndTime">{{errors.serviceEndTime}}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="ui-g-12 p-zero pl-0 pt-0 mt-3 mb-3" *ngIf="attendence?.type?.value ==='clock'">
        <!-- <div class="dropdown-icon ui-g-1">
          <i class="far fa-clock pt-2"></i>
        </div> -->

        <!-- clock start time -->
        <div class="ui-g-6">
          <div class="input-general-settings-wrapper input-default-style margin-zero">
            <div class="time-autocomplete"
              tooltipPosition="top"
              tooltipStyleClass="tech-inprogress-tooltip font-11"
              [pTooltip]="(isToday && isClockIn) ? techName + ' is already Clocked in ' : ''">
              <kendo-timepicker [(value)]="attendenceStartTime" [disabled]="isToday && isClockIn"
                (valueChange)="handleAttendenceTime('attendenceStartTime')"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
              </kendo-timepicker>
              <div class="ml-2 font-10 red" *ngIf="startTimeOverLap">Overlapping detected</div>
              <div class="ml-2 font-10 red" *ngIf="isValidAttendStartTime">Invalid Start time</div>
              <div class="ml-2 font-10 red" *ngIf="errors.attendenceStartTime">{{errors.attendenceStartTime}}</div>
            </div>
          </div>
        </div>

        <!-- <div class="dropdown-icon ui-g-1">
          <i class="far fa-clock pt-2"></i>
        </div> -->

        <!-- clock end time -->
        <div class="ui-g-6">
          <div class="input-general-settings-wrapper input-default-style margin-zero">
            <div class="time-autocomplete"  
            tooltipPosition="top"
            tooltipStyleClass="tech-inprogress-tooltip font-11" [pTooltip]="(isToday && isClockIn) ? techName + ' is already Clocked in ' : ''">
              <kendo-timepicker [(value)]="attendenceEndTime" (valueChange)="handleAttendenceTime('attendenceEndTime')" [disabled]="isToday && isClockIn"
              [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
              </kendo-timepicker>
              <div class="ml-2 font-10 red" *ngIf="endTimeOverLap">Overlapping detected</div>
              <div class="ml-2 font-10 red" *ngIf="isValidAttendEndTime">Invalid End time</div>
              <div class="ml-2 font-10 red" *ngIf="errors.attendenceEndTime">{{errors.attendenceEndTime}}</div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-right float-right attendence-add-footer">

      <button id="attendence-btn-cancel" class="btn btn-white btn-border pointer mr-1 font-bold"
        (click)="closeAttendenceModal($event)">Cancel</button>
      <button id="attendence-btn-save" class="btn btn-primary btn-submit font-bold"
      [ngClass]="{'disabled': (attendence?.type?.value ==='clock' && isToday && isClockIn) }" tooltipPosition="top"
      [pTooltip]="(attendence?.type?.value ==='clock' && isToday && isClockIn) ? techName + ' is already Clocked in ' : ''"
        (click)="handleSubmit()">
        <span class="">Add log</span>
        <i *ngIf="isLoading" class="fal fa-spinner rotate ml-1"></i>
      </button>
    </div>
  </div>

</div>
